import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';

export const useApiWrapper = (endPointFn:any, props = {}, options = {}) => {
    const path = useRef<string>("");
    const location = useLocation();
    
    const [searchParams] = useSearchParams();
  // 1. Use useSelector! React will now watch this value for changes.
     const requiredQuery = ['sectionType','viewType']
     useEffect(()=>{
        let extraPath = ""
      searchParams.forEach((valueEl, keyEl) => {
        if(requiredQuery.includes(keyEl)){
          if(!extraPath.includes(`_${keyEl}_${valueEl}`)){
          extraPath += `_${keyEl}_${valueEl}`
        }
      }
      })
      path.current = location.pathname.replaceAll('/',"_")+extraPath
     },[searchParams,location.pathname])
   const filterProps  = useSelector((state: any) => state.control.filter);
  const finalProps = {
    ...props,
    ...filterProps?.[path.current] ||{},
  }
  return endPointFn(finalProps, options);
};